export const driver = `
    id: uuid
    name
    description
    Etag: etag
    contentId
`
